/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Nav_Configure1Inputs */

const en_coinvestments_nav_configure1 = /** @type {(inputs: Coinvestments_Nav_Configure1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configure`)
};

/**
* | output |
* | --- |
* | "Configure" |
*
* @param {Coinvestments_Nav_Configure1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_nav_configure1 = /** @type {((inputs?: Coinvestments_Nav_Configure1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Nav_Configure1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_nav_configure1(inputs)
});
export { coinvestments_nav_configure1 as "coInvestments_nav_configure" }